<template>
  <v-container>
    <apexchart
      type="radialBar"
      :options="options"
      :series="data"
      length="350px"
      height="350px"
    ></apexchart>
    <v-card-text
      v-if="logo"
      style="position: absolute; top: 30%; width:30%; left:35%;"
      class="text-center text-subtitle-2 font-weight-medium black--text"
    >
      <v-img
        contain
        height="105"
        :src="require('../../assets/tuneinlogo.png')"
        id="homepage-logo"
        v-if="logo && logo === 'tuneIn'"
      />
      <v-img
        contain
        height="105"
        :src="require('../../assets/bluetooth.png')"
        id="homepage-logo"
        v-else-if="logo && logo === 'bluetooth'"
      />
      <v-img
        contain
        height="105"
        :src="require('../../assets/audacy_logo_stacked.png')"
        id="homepage-logo"
        v-else-if="logo && logo === 'audacy'"
      />
      <div
        v-else
        style="height:105px;"
        class="d-flex align-center justify-center"
      >
        <h3>{{ labels[0] }}</h3>
      </div>
      <h3>{{ data[0] }}%</h3>
    </v-card-text>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: ['data', 'labels', 'title', 'customOptions', 'total', 'logo'],
  computed: {
    ...mapGetters({
      _options: 'charts/getRadialChart',
    }),
    options() {
      const options = JSON.parse(JSON.stringify(this._options));
      options.labels = this.labels;
      // options.title.text = this.title;
      const { total } = this;
      options.colors[0] = this.$vuetify.theme.currentTheme.primary;
      options.colors[1] = this.$vuetify.theme.currentTheme.secondary;
      if (total) {
        options.plotOptions.radialBar.dataLabels.total.formatter = function() {
          return total;
        };
      }
      if (this.logo) {
        options.plotOptions.radialBar.dataLabels.show = false;
        options.legend.show = false;
      }
      this.customOptions ? (options.colors = this.customOptions.colors) : '';
      return options;
    },
  },
};
</script>
